import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForTv } from 'utils/index';
import { Platform } from 'utils/platform';

import EasterEggEnvs from 'components/EasterEgg/EasterEggEnvs';

const TvEasterEggScreen: React.FC = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.titleText}>
        {Platform.isWebTV ? 'Ambientes de testes' : 'Menu de desenvolvedor'}
      </Text>
      {Platform.isWebTV && <EasterEggEnvs />}
      {!Platform.isWebTV && (
        <Text style={styles.subtitleText}>Ainda não temos nada por aqui =/</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: calcSizeForTv(120),
  },
  titleText: {
    color: 'white',
    fontSize: calcSizeForTv(48),
    lineHeight: calcSizeForTv(60),
    fontFamily: theme.fonts.inter.bold,
  },
  subtitleText: {
    fontSize: calcSizeForTv(32),
    lineHeight: calcSizeForTv(40),
    marginTop: calcSizeForTv(40),
  },
});

export default TvEasterEggScreen;
